import { React, useContext, useEffect, useState } from 'react'
import { AppContext } from "./../context/AppContext";
import ApiConfig from '../api/ApiConfig';
import { simpleGetCall, simplePostCall } from '../api/ApiServices';
import swal from 'sweetalert';

const TermsAndConditions = () => {
  const { sidebar } = useContext(AppContext);

  const [termsData, setTermsData] = useState({});

  useEffect(() => {
    FetchAllTerms();
  }, [])

  const FetchAllTerms = () => {
    simpleGetCall(ApiConfig.GET_TERMS_AND_CONDITION)
      .then((data) => {
        setTermsData(data.commonText);
        // setLoading(false);
        console.log("Terms Data", data.commonText);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  //  saveTerms 
  const saveTerms = (e) => {
    e.preventDefault();
    let reqBody = JSON.stringify({
      commanTextReq: termsData
    })
    simplePostCall(ApiConfig.UPDATE_TERMS_AND_CONDITION, reqBody)
      .then((res) => {
        console.log("FInal Data", res);
        swal({
          text: res.message,
          icon: "success",
          timer: 2000,
          dangerMode: false,
          button: false
        });
      })
      .catch((err) => {
        // setLoading(false);
        console.log(err);
      });
  }

  return (
    <main id="cx-main" className={sidebar ? "terms-main" : "terms-main cx-active"}>
      <div className="innerContent">
        <div className="heading-common mb-3">
          <label>TERMS AND CONDITIONS</label>
        </div>
        <div className="cx-card-round">
          <div className="form-group">
            <label>Terms And Conditions Content</label>
            <textarea
              className="form-control"
              placeholder="Please write T & C"
              id="floatingTextarea2"
              style={{ height: "250px" }}
              value={termsData}
              onChange={(e) => { setTermsData(e.target.value) }}
            ></textarea>
            <div className="text-end">
              <button className="aboutUsSaveBtn" onClick={saveTerms}>Save</button>
            </div>
          </div>
        </div>
      </div >
    </main >
  )
}

export default TermsAndConditions